import React, { Component } from 'react'
import { StaticBox, LinkedTextArea } from 'components/basic'
import { notify, date } from 'helpers'
import http from 'API/http'
import ReactHtmlParser from 'react-html-parser'
import uuid from 'uuid/v4'
import { connect } from 'react-redux'

class TicketComments extends Component {
  constructor (props) {
    super(props)
    this.state = {
      ticket: null,
      comment: '',
      creating: false
    }
  }

  componentDidMount () {
    this.setState({ticket: this.props.ticket})
  }

  componentWillReceiveProps (props) {
    if (props.lastUpdated === this.props.lastUpdated) return false
    this.setState({ticket: props.ticket})
  }

  async addComment (update) {
    if (this.state.comment.length === 0 || this.state.creating) return
    this.setState({creating: true})
    var [err, res] = await http.put('2.4/tickets/' + this.state.ticket.coTicketReference, {
      comment: {
        message: this.state.comment
      }
    })
    if (err) return notify.alert('Unable to save comment', res.cause, 'error')
    notify.success('Ticket comment created')
    this.setState({comment: '', creating: false})
    this.props.callback()
  }

  render () {
    if (!this.state.ticket) return false
    return (
      <StaticBox cols={12} icon='commenting-o' title='Comments'>
        <div className='row'>
          <div className='col-md-12'>
            {this.state.ticket.status !== 'CLOSED' &&
            <div>
              <div>
                <label>Add comment</label>
                <LinkedTextArea rows={5} context={this} path='comment' />
              </div>
              <div className='row'>
                <div className='col-sm-6' />
                <div className='col-sm-6 text-right mt-10'>
                  <a disabled={this.state.comment.length === 0 || this.state.creating} onClick={e => this.addComment()} className='btn btn-primary'><i className={'fa fa-fw fa-' + (this.state.creating ? 'spin fa-spinner' : 'plus')} /> {(this.state.creating ? 'Creating...' : 'Add Comment')}</a>
                </div>
              </div>
              <hr />
            </div>
            }
            {this.state.ticket.comments.map(comment => {
              return (
                <div key={uuid()}>
                  <label>{comment.createdBy} {date.format(comment.createdAt)}</label>
                  <pre style={{wordWrap: 'break-word', whiteSpace: 'pre-wrap'}}>{ReactHtmlParser(comment.message)}</pre>
                </div>
              )
            })}
          </div>
        </div>
      </StaticBox>
    )
  }
}
//eslint-disable-next-line
TicketComments = connect(state => state)(TicketComments)
export default TicketComments



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/ticket/TicketComments.js